import { render, staticRenderFns } from "./EntityListPage.vue?vue&type=template&id=1ff4f244&scoped=true&"
import script from "./EntityListPage.vue?vue&type=script&lang=ts&"
export * from "./EntityListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4f244",
  null
  
)

export default component.exports